
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	name: 'ChatTabPanel',
	data () {
		return {
			selectedTab: "public",
		}
	},
	computed: {
		...mapState({
			cid: state => state.chatapp.cid,
			roomList: state => state.chatapp.roomList,
			selectedRoom: state => state.chatapp.selectedRoom,
			tempRoom: state => state.chatapp.tempRoom,
		}),
		...mapGetters({
			globalRoom: 'chatapp/globalRoom',
			groupRoomList: 'chatapp/groupRoomList',
		}),
		tabs(){
			return ["public", "personal", ...this.groupRoomList.length? ["group"] : []];
		},
	},
	mounted() {

	},
	methods: {
		onSelectTab(tab){
			this.selectedTab = tab;
			this.$refs.chatFriend.onSelectTab(tab);
		},
	},
	watch: {
		"globalRoom"(newValue, oldValue){
			console.log({newValue, oldValue})
			if(newValue && !oldValue){
				this.onSelectTab("public");
			}
		}
	}
}
